/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decline_Button_LabelInputs */

const en_decline_button_label = /** @type {(inputs: Decline_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const nl_decline_button_label = /** @type {(inputs: Decline_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weigeren`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Decline_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const decline_button_label = /** @type {((inputs?: Decline_Button_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decline_Button_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_decline_button_label(inputs)
	return en_decline_button_label(inputs)
});